import {searchCriteria} from "./searchCriteria";

export function ReportSearchCriteria(dateWindowId="", district="") {

    return Object.assign({}, searchCriteria("ReportSearchCriteria", "districtId", "districtId"), {
        dateWindowId,
	    district,
    });
}